import { ordersApi } from "components/Apis/orders";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const OrdersWithChangedUnitsBoard = ({ }) => {
    const [dubiousUnitOrders, setDubiousUnitOrders] = useState(null);

    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);


    useEffect(() => {
        if (briefing == "Old Briefings" || searchTerm) {
            setDubiousUnitOrders(null);
        }
        else {
            (async () => {
                const data = await ordersApi.getActiveOrdersWithChangedVehicleSize();
                setDubiousUnitOrders(data.data);
            })();
        }

    }, [startDate, endDate, searchTerm, briefing]);


    return (
        <>
            {dubiousUnitOrders && dubiousUnitOrders.length > 0 && (
                <>
                    <p className="pop-badge">Unit Size Change Log:</p>
                    <table className="briefing-table sub-section-table">
                        <thead>
                            <tr>
                                <th>Pro #</th>
                                <th>Units</th>
                                <th>Dims (L x W x H)</th>
                                <th>Original Vehicle Size</th>
                                <th>Update Note</th>
                                <th>Deliver To</th>
                                <th>Delivery Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dubiousUnitOrders ? (
                                dubiousUnitOrders.map((order, index) => (
                                    <tr key={index}>
                                        <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                                        <td>{order.units}</td>
                                        <td>{order.length} x {order.width} x {order.height}</td>
                                        <td>{order.original_vehicle_size}</td>
                                        <td>
                                            {order.last_update.message}
                                        </td>
                                        <td>{order.deliver_to}</td>
                                        <td>{order.delivery_date}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5">No orders with dubious units found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <hr />
                </>
            )
            }
        </>
    );
};

export default OrdersWithChangedUnitsBoard;